var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.833984C15.0627 0.833984 19.1667 4.93804 19.1667 10.0007C19.1667 15.0633 15.0627 19.1673 10 19.1673C4.93743 19.1673 0.833374 15.0633 0.833374 10.0007C0.833374 4.93804 4.93743 0.833984 10 0.833984ZM14.0421 7.48109L14.6313 8.07034C14.794 8.23306 14.794 8.49688 14.6313 8.6596L9.32801 13.9629C9.16529 14.1256 8.90148 14.1256 8.73876 13.9629L5.68841 10.9126C5.52569 10.7498 5.52569 10.486 5.68841 10.3233L6.27767 9.73404C6.44038 9.57132 6.7042 9.57132 6.86692 9.73404L9.03332 11.9004L13.4528 7.48109C13.6155 7.31837 13.8793 7.31837 14.0421 7.48109Z",
    fill: "#1AC84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllow);
export default __webpack_public_path__ + "static/media/Allow.8a41a94748443612d7f5a52e128aae1c.svg";
export { ForwardRef as ReactComponent };